import { Image } from '@atoms/Images';
// import { useOktaAuth } from '@okta/okta-react';
import { userAtom } from '@states/Atoms';
import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

const AuthUserInfo = () => {
    const userInformation: any = useRecoilValue(userAtom.infomationState);
    // const { oktaAuth } = useOktaAuth();
    // const logout = async () => {
    //     await oktaAuth.signOut({
    //         postLogoutRedirectUri: window.location.origin
    //     }).catch((err) => {
    //         console.log(err);
    //     });
    // };
    return (
        <UserInformationWithStyled className='loginUser'>
            <NavDropdown title={<Image src="/img/icon/iconmonstr-user-6-32.png" alt="ログイン情報" />}>
                <NavDropdown.ItemText>{userInformation.name} さん</NavDropdown.ItemText>
                {/* <NavDropdown.Item href="#" onClick={logout}>ログアウト</NavDropdown.Item> */}
            </NavDropdown>
        </UserInformationWithStyled>
    );
};

const UserInformationWithStyled = styled.div`
`

export default AuthUserInfo;